import { ConversationDto } from '@/Domain/api/Conversation/dto/Conversation.dto';
import { ConversationAssigneeEnum } from '@/Domain/enum/ConversationAssignee.enum';
import { ConversationStatusEnum } from '@/Domain/enum/ConversationStatus.enum';
import { PostHogEventEnum } from '@/Domain/enum/PostHogEvent.enum';
import { usePostHogAnalytics } from '@/Domain/hooks/App/usePostHog/usePostHogAnalytics.hook';
import { useUpdateConversation } from '@/Domain/hooks/Conversation/useUpdateConversation.hook';
import { useUser } from '@/Domain/hooks/User/useUser.hook';

export const useChangeConversationStatus = (conversation: ConversationDto) => {
  const { user } = useUser();
  const { handleUpdate, isPending } = useUpdateConversation(conversation.id);
  const { capture } = usePostHogAnalytics();

  const canChangeStatus =
    conversation.assignee.type === ConversationAssigneeEnum.HUMAN_OPERATOR
      ? conversation.assignee.user.id === user?.id
      : false;

  const handleChangeStatus = (status: ConversationStatusEnum) => {
    const event =
      status === ConversationStatusEnum.Resolved
        ? PostHogEventEnum.ConversationResolved
        : PostHogEventEnum.ConversationReopened;

    capture(event, {
      conversation_id: conversation.id,
      source: conversation.source,
      previous_status: conversation.resolution_status,
    });

    return handleUpdate({ resolution_status: status });
  };

  return {
    handleChangeStatus,
    canChangeStatus,
    isPending,
  };
};
